import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    ChangeUserSettings,
    updateUserSettings,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    LabelValue,
    Input,
    Collapse,
} from "client/components"

import FormatPercentage from "client/pages/sil/format/percentage"
import { customParseInt, customParseFloat } from "client/pages/sil/format/parse"


const Iec615082010 = () => {
    const settings = useSelector((state: StoreType) => state.userSettings.settings.sil)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (value: ChangeUserSettings) => {
        dispatch(updateUserSettings("sil", value))
    }

    const { iec615082010 } = settings
    const {
        t1,
        mttr,
        mrt,
        beta,
        betaD,
        k,
    } = iec615082010

    return (
        <Collapse
            show={show}
            title={lang.defaultIec_61508_2010_settings}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>
                        {lang.defaultT1}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={t1}
                        onChange={(e) => onChange({
                            iec615082010: {
                                ...iec615082010,
                                t1: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            iec615082010: {
                                ...iec615082010,
                                t1: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>
                        {lang.defaultMttr}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={mttr}
                        onChange={(e) => onChange({
                            iec615082010: {
                                ...iec615082010,
                                mttr: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            iec615082010: {
                                ...iec615082010,
                                mttr: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>
                        {lang.defaultMrt}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={mrt}
                        onChange={(e) => onChange({
                            iec615082010: {
                                ...iec615082010,
                                mrt: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            iec615082010: {
                                ...iec615082010,
                                mrt: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>

                <FormatPercentage
                    title={lang.defaultBeta}
                    data={beta}
                    onChange={(value) => onChange({
                        iec615082010: {
                            ...iec615082010,
                            beta: customParseFloat(value),
                        },
                    })}
                />
                <FormatPercentage
                    title={lang.defaultBetaD}
                    data={betaD}
                    onChange={(value) => onChange({
                        iec615082010: {
                            ...iec615082010,
                            betaD: customParseFloat(value),
                        },
                    })}
                />
                <FormatPercentage
                    title={lang.defaultK}
                    data={k}
                    onChange={(value) => onChange({
                        iec615082010: {
                            ...iec615082010,
                            k: customParseFloat(value),
                        },
                    })}
                />
            </PageForm>
        </Collapse>
    )
}
export default Iec615082010
